export const selectUserConfig = (state: WebOrder.State) =>
  state.flipdish.Customer &&
  state.flipdish.Customer.status === 'success' &&
  state.flipdish.Customer.data;
